import { BasicAccountAnalyticsPayload } from '@anytag/graphql';
import { Anchor, Icon, TextCutter } from '@anytag/shared-atoms';
import { Header, InfluencerAvatar } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';
import { AnalyticsSelectedAccountInfo } from '../types';
import { AnalyticsHeaderActions } from './AnalyticsHeaderActions';

export interface AnalyticsHeaderProps {
  className?: string;
  brandAccount: BasicAccountAnalyticsPayload;
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const AnalyticsHeader = ({ className, brandAccount, analyticsAccount }: AnalyticsHeaderProps) => (
  <>
    <Header />
    <div
      className={cn(
        'box-border flex h-16 items-center justify-between gap-x-1 rounded-sm bg-white px-4 py-2',
        className
      )}
    >
      <div className="flex items-center gap-x-2.5">
        <InfluencerAvatar size="48px" src={analyticsAccount.avatar} className="rounded-full border-base-border" />
        <div>
          <TextCutter
            lines={2}
            text={brandAccount.brandAccountName}
            className="max-w-88 text-md font-medium text-black-90"
          />
          <Anchor
            variant="blue"
            target="_blank"
            href={analyticsAccount.socialMediaUrl}
            className="flex items-center gap-1.5 text-sm leading-4"
          >
            {analyticsAccount.socialAccountName}
            <Icon icon="external-link" size={14} variant="inherit" />
          </Anchor>
        </div>
      </div>

      <AnalyticsHeaderActions brandAccount={brandAccount} analyticsAccount={analyticsAccount} />
    </div>
  </>
);
